import { getDomain } from '@src/tools/getDomain';

export const TITLE_MAP = {
  '/': 'Home',
  '/claims/trackit': 'Claims | Trackit',
  '/paan/trackit': 'PAAN | Trackit',
  '/referrals/trackit': 'Referrals | Trackit',
  '/trackit': 'Trackit',
  '/claim-submission': 'Claim Submission',
  '/claims': 'Claims',
  '/eligibility': 'Eligibility',
  '/referral': 'Referrals',
  '/prefcenter': 'Preference Center',
  '/feeschedulelookup': 'Fee Schedule Lookup',
  '/documentlibrary': 'Document Library',
  '/mpp': 'MPP',
  '/report-hub': 'Report Hub',
  '/contact-us': 'Contact Us',
  '/additional-tools': 'Additional Tools',
  '/app-search': 'App Search',
  '/uhcp-forms': 'UHCP Forms',
  '/paan': 'PAAN',
  '/onboard-pro': 'Onboard Pro',
  '/accessmanagement': 'Access Management',
  '/code-lookup': 'Code Lookup',
  '/contact-us/network-help': 'Network Help and Support',
};

export const PRODUCT_DOMAINS = {
  claims: getDomain('sde-claims', 3200),
  claimsub: getDomain('sde-claimsub', 3900),
  digisec: getDomain('sde-digisec', 3700),
  documentlibrary: getDomain('sde-documentlibrary', 3500),
  eligibility: getDomain('sde-eligibility', 3100),
  'fee-schedule-lookup': getDomain('sde-fee-schedule-lookup', 4000),
  mpp: getDomain('sde-mpp', 3800),
  obp: getDomain('sde-obp', 8919),
  paan: getDomain('sde-paan', 4789),
  prefcenter: getDomain('sde-prefcenter', 3600),
  referrals: getDomain('sde-referrals', 3300),
  'report-hub': getDomain('sde-report-hub', 4590),
  trackit: getDomain('sde-trackit', 3400),
  'uhcp-forms': getDomain('sde-uhcp-forms', 5200),
  'code-lookup': getDomain('sde-code-lookup', 9999), // update port as needed
};

export const getTitle = (pathname) => {
  // Find the longest matching key (for nested routes)
  const match = Object.keys(TITLE_MAP)
    .filter((key) => pathname === key || pathname.startsWith(key + '/'))
    .sort((a, b) => b.length - a.length)[0];
  return TITLE_MAP[match] || 'Home';
};
